import React from "react";
import CustomForm from "./NewsletterSubscribe";
import { FaSpotify, FaYoutube, FaInstagram } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="flex flex-col p-10 text-center bg-footer justify-evenly lg:flex-row">
      {/* Col 1 */}
      <div className="flex flex-col space-y-2 text-lg text-center white lg:space-y-3">
        <h3 className="text-lg footer-heading sm:mb-4 sm:text-2xl lg:mb-1">
          some important stuff
        </h3>
        <a
          href="/bio"
          className="text-sm text-gray-1 footer-text hover:text-skin-accent sm:text-lg"
        >
          Bio
        </a>
        <a
          href="/"
          className="text-sm text-gray-1 footer-text hover:text-skin-accent sm:text-lg"
        >
          Store
        </a>
        <a
          href="/"
          className="text-sm text-gray-1 footer-text hover:text-skin-accent sm:text-lg"
        >
          Videos
        </a>
      </div>

      {/* Col 2 */}
      <div class="flex h-full flex-col justify-center text-center">
        <h3 class="footer-heading text-light-gray mt-8 text-lg sm:mb-4 sm:text-2xl lg:mt-0 lg:mb-7">
          connect
        </h3>
        <div class="white my-5 flex items-center justify-center space-x-10 text-4xl sm:my-0">
          <a class="link" href="/">
            <FaSpotify class="fa-brands text-gray-1 hover:text-skin-accent "></FaSpotify>
          </a>
          <a class="link" href="/">
            <FaYoutube class="fa-brands text-gray-1 fa-youtube hover:text-skin-accent"></FaYoutube>
          </a>
          <a class="link" href="/">
            <FaInstagram class="fa-brands text-gray-1 fa-instagram hover:text-skin-accent"></FaInstagram>
          </a>
        </div>
      </div>

      {/* Col 3 */}
      <div class="mt-10 flex h-full flex-col justify-center text-center lg:mt-0">
        <h3 class="footer-heading text-light-gray text-lg sm:text-2xl">
          Newsletter
        </h3>
        <CustomForm></CustomForm>
      </div>
    </footer>
  );
}
